import VueLodash from "vue-lodash";
import _ from 'lodash'
import Vue from 'vue'

Vue.use(VueLodash, { lodash: _ });

const components = require.context('../components/xray')
_.forEach(components.keys(), (fileName) => {
  const componentConfig = components(fileName)
  const componentName = fileName.split('/').pop().split('.')[0]
  Vue.component(componentName, componentConfig.default || componentConfig)
})
